import './AllForIFrame.scss';
import React, { useContext } from 'react';
import IFrame from './IFrame';
import { IComponentIFrame } from '../../component.d';

const AllForIFrame = function(props: IComponentIFrame) {
  const { url, height } = props;

  return (
    <div className="all-for-iframe" style={{ height: height }}>
      <IFrame url={url} />
    </div>
  );
};

export default AllForIFrame;
